import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../types/product.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import { FacetPickerHeader } from '../../../components/FacetPickers/components/FacetPickerHeader.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import { ReadyReaderPowerSelector } from './components/ReadyReaderPowerSelector/ReadyReaderPowerSelector.js';

const ReadyReaderPowerSection = ({ className  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(className, 'ready-reader-power-section')
    }, /*#__PURE__*/ React.createElement(FacetPickerHeader, {
        enableStockIndicator: true
    }, getLabel('products.readyreaders.power')), /*#__PURE__*/ React.createElement(ReadyReaderPowerSelector, null));
};

export { ReadyReaderPowerSection };
//# sourceMappingURL=ReadyReaderPowerSection.js.map
